import {
  CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_BEGIN,
  CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_SUCCESS,
  CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_FAILURE,
  CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCustomComponentConfig(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_BEGIN,
    });

    const { projectId, version, customComponentId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/custom-component/${customComponentId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCustomComponentConfigError() {
  return {
    type: CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_BEGIN:
      return {
        ...state,
        loadCustomComponentConfigPending: true,
        loadCustomComponentConfigError: null,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_SUCCESS:
      return {
        ...state,
        loadCustomComponentConfigPending: false,
        loadCustomComponentConfigError: null,
        currentCustomComponent: action.data,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_FAILURE:
      return {
        ...state,
        loadCustomComponentConfigPending: false,
        loadCustomComponentConfigError: action.data.error,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR:
      return {
        ...state,
        loadCustomComponentConfigError: null,
      };

    default:
      return state;
  }
}
